export default {"src":"/_next/static/media/CrossSIP.3e276a0f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};